import LineInterface from 'app/interfaces/LineInterface';

import {isNestedLine} from 'app/lines/isNestedLine';

export const isSecondLevelNested = (line: LineInterface): boolean => Boolean(isNestedLine(line) && line.parent.parent);
